import { CoinHistorySelectTab } from './CoinHistorySelectTab'
import { withCoinHistorySelectTab } from './withCoinHistorySelectTab'

const ConnectedCoinHistorySelectTab =
  withCoinHistorySelectTab(CoinHistorySelectTab)

export { ConnectedCoinHistorySelectTab as CoinHistorySelectTab }
